var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "top" },
      [_c("gao-kao-step", { attrs: { active: 0 } })],
      1
    ),
    _c(
      "div",
      { staticClass: "card-container" },
      _vm._l(_vm.tableData, function (thData, thIndex) {
        return _c(
          "el-row",
          { key: thIndex },
          _vm._l(thData, function (item, index) {
            return _c("el-col", { key: index, attrs: { span: 8 } }, [
              item.newTip
                ? _c(
                    "div",
                    {
                      staticClass: "card",
                      style: item.customStyle,
                      on: {
                        click: function ($event) {
                          return _vm.handleClick(item.areaCode, true)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "content", style: item.areaNameStyle },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.examEnum[item.areaCode].desc + item.areaName
                            )
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "extra" },
                        [
                          _vm._v(" " + _vm._s(item.areaDesc) + "（新版） "),
                          _c(
                            "el-tooltip",
                            {
                              attrs: { content: item.newTip, placement: "top" },
                            },
                            [_c("span", { staticClass: "el-icon-question" })]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "jump-old",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleClick(item.areaCode)
                                },
                              },
                            },
                            [_vm._v("进入旧版")]
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "card",
                      style: item.customStyle,
                      on: {
                        click: function ($event) {
                          return _vm.handleClick(item.areaCode)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "content", style: item.areaNameStyle },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.examEnum[item.areaCode].desc + item.areaName
                            )
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "extra" }, [
                        _vm._v(" " + _vm._s(item.areaDesc) + " "),
                      ]),
                    ]
                  ),
            ])
          }),
          1
        )
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }